import img1 from '../Assets/Images/3GNL.jpg';
import img2 from '../Assets/Images/CST_logo.png';
import img3 from '../Assets/Images/monky user.png';
import img4 from '../Assets/Images/redy to roll.jpg';

export const mediaTypes = [
  { itemValue: 'TWY DIAG', itemLabel: 'TWY DIAG' },
  { itemValue: 'AERIAL', itemLabel: 'AERIAL' },
  { itemValue: 'RAMP', itemLabel: 'RAMP' },
  { itemValue: 'TERMINAL', itemLabel: 'TERMINAL' },
  { itemValue: 'DESTINATION', itemLabel: 'DESTINATION' },
];

export const mediaNames = ['TWY DIAG', 'AERIAL', 'RAMP', 'TERMINAL', 'DESTINATION'];

export const mediaExample = [
  {
    id: 1,
    type: 'TERMINAL',
    img: img1,
    imgAlt: 'img1',
  },
  {
    id: 2,
    type: 'TERMINAL',
    img: img2,
    imgAlt: 'img1',
  },
  {
    id: 3,
    type: 'AERIAL',
    img: img3,
    imgAlt: 'img1',
  },
  {
    id: 4,
    type: 'DESTINATION',
    img: img4,
    imgAlt: 'img1',
  },
  {
    id: 6,
    type: 'TWY DIAG',
    img: img2,
    imgAlt: 'img1',
  },
  {
    id: 7,
    type: 'TWY DIAG',
    img: img3,
    imgAlt: 'img1',
  },
  {
    id: 8,
    type: 'TWY DIAG',
    img: img1,
    imgAlt: 'img1',
  },
  {
    id: 9,
    type: 'AERIAL',
    img: img2,
    imgAlt: 'img1',
  },
  {
    id: 10,
    type: 'RAMP',
    img: img4,
    imgAlt: 'img1',
  },
];
